import { api } from "../lib/api";
import type { ClientProfile, UpdateProfileInput } from "@yogo/shared";

export const profileService = {
  async get(): Promise<{ success: boolean; data: ClientProfile }> {
    const res = await api.get("/profile");
    return res.data;
  },

  async update(
    input: UpdateProfileInput,
  ): Promise<{ success: boolean; data: ClientProfile }> {
    const res = await api.put("/profile", input);
    return res.data;
  },
};

// Day 18 complete
